export default {
    // Maximum number of keyword boxes shown in the application log filter.
    // Keep this in sync with the backend LogSettings::searchMaxKeywords().
    MAX_KEYWORDS: 5
};



// WEBPACK FOOTER //
// ./src/app/constants/applicationLog/index.js